import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { saveQuest } from "@/lib/quest";

export const WELCOME_CONSENT = "Yes, email me Grandpa Finn's news and offers. Unsubscribe any time.";

const CodeReveal = ({ code, testPrefix, dark }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(code); setCopied(true); toast.success("Code copied."); }
    catch { toast.error("Couldn't copy. Select the code instead."); }
  };
  return (
    <div data-testid={`${testPrefix}-code-reveal`} className={`rounded-2xl border-2 border-dashed p-4 ${dark ? "border-sunny/60" : "border-navy/30 bg-white"}`}>
      <p className="text-sm">Your 10% off code for your first order:</p>
      <div className="mt-2 flex items-center gap-3">
        <span data-testid={`${testPrefix}-code`} className="font-mono text-2xl font-bold tracking-widest select-all">{code}</span>
        <button type="button" data-testid={`${testPrefix}-copy-button`} onClick={copy}
          className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold ${dark ? "bg-sunny text-navy" : "bg-navy text-sunny"}`}>
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}{copied ? "Copied" : "Copy"}
        </button>
      </div>
      <p className={`mt-2 text-xs ${dark ? "text-sand/70" : "text-slate-600"}`}>Enter it with this email in the cart.</p>
    </div>
  );
};

export const WelcomeSignup = ({ source, testPrefix, dark = false, onDone }) => {
  const [email, setEmail] = useState("");
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [code, setCode] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    if (!agree) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email, source, consent: true });
      setCode(data.code);
      saveQuest({ code: data.code, email });
      onDone?.();
    } catch (err) { toast.error(errMsg(err, "That email doesn't look right.")); }
    finally { setBusy(false); }
  };
  if (code) return <CodeReveal code={code} testPrefix={testPrefix} dark={dark} />;
  return (
    <form onSubmit={submit} data-testid={`${testPrefix}-form`} className="space-y-3">
      <input data-testid={`${testPrefix}-email-input`} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" aria-label="Email address"
        className="w-full h-12 rounded-full border border-navy/15 px-5 bg-white text-navy focus:outline-none focus:ring-4 focus:ring-aqua" />
      <label className="flex items-start gap-2 text-sm cursor-pointer">
        <input data-testid={`${testPrefix}-consent-checkbox`} type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-1 h-4 w-4 shrink-0 accent-navy" />
        <span>{WELCOME_CONSENT}</span>
      </label>
      <button data-testid={`${testPrefix}-submit-button`} disabled={!agree || busy}
        className={`btn-pop w-full disabled:opacity-40 disabled:cursor-not-allowed ${dark ? "bg-sunny text-navy" : "bg-navy text-sunny"}`}>{busy ? "..." : "Get my code"}</button>
    </form>
  );
};
